import { Component } from '@angular/core';

import { ModalService } from 'services';

@Component({
    selector: 'fc-upgrade-plan',
    templateUrl: './upgrade-plan.component.html',
    styleUrls: ['./upgrade-plan.component.less'],
    standalone: false
})
export class UpgradePlanComponent {
    constructor(private modalService: ModalService) {}

    close() {
        this.modalService.close('upgrade-plan');
    }
}
